import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { traceability } from '../../data/semanticKnowledge';
import { fadeUp } from '../../utils/motion';
export function SkpFoundation() {
  return <section className="bg-surface-bg py-20 lg:py-28" data-id="element-2533" data-mp="1jw5q4ozar0lm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16" data-id="element-2534" data-mp="1fubvaxbs8qtd">
        <motion.div {...fadeUp} className="lg:col-span-5" data-id="element-2535" data-mp="2ckkqq6holgdf">
          <h2 className="font-heading font-bold text-4xl lg:text-5xl text-ink-dark tracking-tight leading-tight mb-6" data-id="element-2536" data-mp="2cm5khtw68va8">
            One foundation, multiple applications
          </h2>
          <p className="text-lg text-ink-muted leading-relaxed" data-id="element-2537" data-mp="22sopimkata4z">
            SKP’s value is its ability to carry knowledge from source to action
            without losing the path between them.
          </p>
        </motion.div>

        <motion.div {...fadeUp} className="lg:col-span-7" data-id="element-2538" data-mp="2qkccitefw11z">
          <ul className="border-t border-line" data-id="element-2539" data-mp="2qisv2zh1rjym">
            {traceability.map(row => <li key={row.from} className="grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr] items-center gap-2 sm:gap-6 border-b border-line py-6" data-id="element-2540" data-mp="31pdgu3crr3fc">
                <span className="font-heading font-bold text-xl text-ink-dark" data-id="element-2541" data-mp="2ryaeky83sieh">
                  {row.from}
                </span>
                <span className="flex items-center gap-2 text-sm text-teal font-medium whitespace-nowrap" data-id="element-2542" data-mp="2wvsha6vj21e1">
                  traces to
                  <ArrowRight size={16} aria-hidden="true" data-id="element-2543" data-mp="2ny03j75gf1sr" />
                </span>
                <span className="text-lg text-ink-muted" data-id="element-2544" data-mp="290fzc2gdtann">{row.to}</span>
              </li>)}
          </ul>
          <p className="mt-10 text-2xl text-ink-dark leading-relaxed" data-id="element-2545" data-mp="2dyhisohpzbzn">
            That is how SyNeural builds intelligence that can be examined,
            improved, and held accountable.
          </p>
        </motion.div>
      </div>
    </section>;
}